export default __webpack_public_path__ + "static/media/marketCap.424c4ec3.svg";